import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Cart = () => {
    const [cart, setCart] = useState([]);
    const [subTotal, setSubTotal] = useState(0);
    const shipping = 9.99;

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
        setCart(storedCart);
    }, []);
    useEffect(() => {
        const total = cart.reduce(
            (sum, item) => sum + item.price * item.quantity,
            0
        );
        setSubTotal(total);
    }, [cart]);
    const handleMinus = (index) => {
        setCart((prev) => {
            const updated = prev.map((item, i) =>
                i === index
                    ? { ...item, quantity: Math.max(1, item.quantity - 1) }
                    : item
            );
            localStorage.setItem("cart", JSON.stringify(updated));
            window.dispatchEvent(new Event("cartUpdated"));
            return updated;
        });
    };

    const handlePlus = (index) => {
        setCart((prev) => {
            const updated = prev.map((item, i) =>
                i === index ? { ...item, quantity: item.quantity + 1 } : item
            );
            localStorage.setItem("cart", JSON.stringify(updated));
            window.dispatchEvent(new Event("cartUpdated"));
            return updated;
        });
    };


    const handleRemove = (index) => {
        const updated = cart.filter((_, i) => i !== index);
        setCart(updated);
        localStorage.setItem("cart", JSON.stringify(updated));
        window.dispatchEvent(new Event("cartUpdated"));
    };

    return (
        <>
            <section className="inner-banner">
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div
                            className="col-md-6"
                            data-aos="flip-left"
                            data-aos-duration={2000}
                        >
                            <div className="inner-banner-left">
                                <h1>Cart</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="inner-banner-right">
                                <img src="images/hero-tires.png" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
                <h2>Tyres</h2>
            </section>

            <section className="shopping_cart inner-bg">
                <div className="container">
                    <div className="row align-items-center">
                        <div
                            className="col-lg-8 col-md-7 col-sm-12 col-12"
                            data-aos="flip-left"
                            data-aos-duration={1000}
                        >
                            <div className="shopping_cart_table">
                                <h2>Shopping Cart</h2>
                                <div className="table-responsive">
                                    {cart.length > 0 ? (
                                        <table className="w-100">
                                            <thead>
                                                <tr>
                                                    <th>Product</th>
                                                    <th>Quantity</th>
                                                    <th>Total Price</th>
                                                    <th>Remove</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cart.map((item, index) => (
                                                    <tr key={item.ProductCode}>
                                                        <td>
                                                            <div className="cart_box_product">
                                                                <div className="cart_product_img">
                                                                    <img src={item.image} alt={item.name} />
                                                                </div>
                                                                <div className="cart_product_name">
                                                                    <p>{item.brand}</p>
                                                                    <h5>{item.name}</h5>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="quanity product-detail cart-pag-qunty">
                                                                <div className="num-block skin-2">
                                                                    <div className="num-in">
                                                                        <span
                                                                            className={`minus ${item.quantity <= 1 ? "dis" : ""
                                                                                }`}
                                                                            onClick={() => handleMinus(index)}
                                                                        />
                                                                        <input
                                                                            className="in-num"
                                                                            type="text"
                                                                            value={item.quantity}
                                                                            readOnly
                                                                        />
                                                                        <span
                                                                            className="plus"
                                                                            onClick={() => handlePlus(index)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <p className="t_price">
                                                                £{(item.price * item.quantity).toFixed(2)}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <button
                                                                onClick={() => handleRemove(index)}
                                                                className="remove_btn"
                                                            >
                                                                <i className="fas fa-times" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <>
                                            <div className="not_found">
                                                Your cart is empty.
                                            </div>
                                            <div className="cart_recipt">
                                                <Link to="/product">Continue Shopping</Link>
                                            </div>
                                        </>
                                    )}
                                </div>

                                {cart.length > 0 && (
                                    <div className="cart_recipt">
                                        <Link to="/product">Continue Shopping</Link>
                                    </div>
                                )}
                            </div>
                        </div>
                        {cart.length > 0 && (
                            <div
                                className="col-lg-4 col-md-5 col-sm-12 col-12"
                                data-aos="flip-right"
                                data-aos-duration={1000}
                            >
                                <div className="recipt">
                                    <ul>
                                        <li>
                                            Subtotal:{" "}
                                            <span>£{subTotal.toFixed(2)}</span>
                                        </li>
                                        <li>
                                            Shipping: <span>£{shipping.toFixed(2)}</span>
                                        </li>
                                        <li className="fw-bold">
                                            Total:{" "}
                                            <span>£{(subTotal + shipping).toFixed(2)}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="cart_recipt recipt_checkt">
                                    <Link to="/checkout">Proceed To Checkout</Link>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Cart;
